import { TAG_TYPES } from '../types/TagTypes';
export function convertDynamicPageModel(payload) {
  if (!payload || Object.keys(payload).length === 0) {
    return {
      tags: []
    };
  }

  var tags = Object.assign({}, payload.description ? {
    description: payload.description
  } : {}, payload.keywords ? {
    keywords: payload.keywords
  } : {}, {
    robots: payload.noIndex === 'true' || payload.noIndex === true ? 'noindex' : 'index'
  }, !Array.isArray(payload.metaTags) && payload.metaTags || {});
  var parsedTags = Object.keys(tags).reduce(function (acc, curr) {
    var _props;

    var nameOrProperty = curr.indexOf('og:') === 0 ? 'property' : 'name';
    return acc.concat({
      type: TAG_TYPES.META,
      props: (_props = {}, _props[nameOrProperty] = curr, _props.content = tags[curr], _props)
    });
  }, []);

  if (payload.title) {
    parsedTags.push({
      type: TAG_TYPES.TITLE,
      children: payload.title
    });
  }

  return {
    tags: parsedTags
  };
}